export default {
    data() {
        return {
            tripsStatuses: [
                { id: 1, label: 'Confirmed', name: 'confirmed' },
                { id: 3, label: 'Action Required', name: 'action-required' },
                { id: 4, label: 'Scheduled', name: 'scheduled' },
                { id: 5, label: 'Completed', name: 'completed' },
                { id: 6, label: 'Verified', name: 'verified' },
                { id: 7, label: 'Paired', name: 'paired' },
                { id: 8, label: 'Shared-Private', name: 'shared-private' },
                { id: 9, label: 'Private', name: 'private' }
            ],
        }
    },
    methods: {
        getStatus(name) {
            return this.tripsStatuses.filter(status => status.name == name)[0]['id'];
        }
    },
}